module.exports = __webpack_public_path__ + "static/media/MHRP75N0003.0a83c86d.svg";